'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowForward = function TiArrowForward(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.7 9.2c-0.5 0-0.9 0.1-1.2 0.5-0.3 0.3-0.5 0.7-0.5 1.1v4.3c-7.5 0.8-13.3 7.2-13.3 14.9v1.7c3.7-5.7 8.7-6.6 13.3-6.7v4.2c0 0.4 0.2 0.8 0.5 1.1s0.7 0.5 1.2 0.5 0.8-0.1 1.1-0.5l10.5-10.3-10.5-10.3c-0.3-0.4-0.7-0.5-1.1-0.5z' })
        )
    );
};

exports.default = TiArrowForward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-forward.js
// module id = 1949
// module chunks = 0